import * as R from "ramda";
import { getCommonSelectorProps } from "common/app/command-palette/selectors";
import { globalSearchApi } from "common/api/global-search";
import { RenderModuleProps } from "common/app/command-palette/types";
import { ReactHighlightWords } from "common/vendor-wrappers/react-highlight-words";
import {
  FormatMeta,
  LabelledOptionOrGroup,
} from "common/vendor-wrappers/react-select/types";
import { MAX_SELECTOR_RECORDS } from "common/widgets/record-selector/functions";
import { AsyncSelector } from "common/widgets/selector/async-selector";
import { SearchRecord } from "x/layout/header/global-search/types";

const optionsForFields = (records: SearchRecord[]) =>
  R.groupWith(
    (a, b) => a.entity === b.entity,
    R.sortBy((r) => r.entity, records),
  ).map((records) => ({
    label: records[0].entity,
    options: R.sortBy(
      (r) => r.label,
      records.map((record) => ({ label: record.title, value: record })),
    ),
  }));

export function GlobalSearchModule({
  context,
  goTo,
  onCommandSelected,
}: Readonly<RenderModuleProps>) {
  const fetchRecords = (term: string, limit: number) =>
    globalSearchApi(context.apiCall)
      .searchListByEntity(term, "all", 0, limit)
      .then((paginationValue) => paginationValue.data);

  const mapOptions = (records: SearchRecord[]) => {
    return optionsForFields(records);
  };

  const formatItem = (
    item: LabelledOptionOrGroup<SearchRecord>,
    meta: FormatMeta<SearchRecord>,
  ) => {
    return <ReactHighlightWords text={item.label} search={meta?.inputValue} />;
  };

  const onOptionSelect = (option: SearchRecord) => {
    goTo(`/#/${context.site.name}/${option.entity}/${option.id}`);
    onCommandSelected();
  };

  return (
    <div className="x-global-records-search">
      <AsyncSelector
        {...getCommonSelectorProps()}
        fetch={fetchRecords}
        mapOptions={mapOptions}
        formatOptionLabel={formatItem}
        placeholder={_("Search All Records")}
        label={undefined}
        disabled={false}
        allowClear={false}
        optionsLimit={MAX_SELECTOR_RECORDS}
        value={undefined}
        onChange={onOptionSelect}
      />
    </div>
  );
}

GlobalSearchModule.displayName = "GlobalSearchModule";
